module.exports = __webpack_public_path__ + "img/image_02.b131c420.png";